import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import useStateRef from 'react-usestateref';
import Loader from '../Loader/Loader';
import Helper from '../Helper';
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { APPLICATION_JSON, DEFAULT_IMAGE_60 } from '../../middleware/types';
import heap from 'reactjs-heap';
import { monetateDetailsAction } from '../../middleware/monetateDetailsAction';

const OrderConfirmation = ({ containerObject, templateName, contentId, dataZone }) => {
    console.log('heapTrackOrderId...', containerObject.heapTrackOrderId);
    let history = useHistory();
    var clickIdUrlParameter = "clickId";
    var clickIdCookieName = "pjn_clicks";
    var lookbackPeriodInDays = "30";
    var cookieDataParsed;
    var maxCookieAge = lookbackPeriodInDays * (60 * 24 * 60);
    const [pwd, setPwd] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [isRevealPwd, setIsRevealPwd] = useState(false);
    const [search, setSearch, searchRef] = useStateRef("");
    const [hasError, setHasError, hasErrorRef] = useStateRef(false);
    const [isGuestUser, setIsGuestUser, isGuestUserRef] = useStateRef(false);
    const [isRedeem, setIsRedeem, isRedeemRef] = useStateRef();
    const [orderConfirmationDetails, setOrderConfirmationDetails, orderConfirmationDetailsRef] = useStateRef();
    const [redeemOrderConfirmationDetails, setRedeemOrderConfirmationDetails, redeemOrderConfirmationDetailsRef] = useStateRef();
    const [shippingAddressMap, setShippingAddressMap, shippingAddressMapRef] = useStateRef()
    const [paymentAddressMap, setPaymentAddressMap, paymentAddressMapRef] = useStateRef()

    const [curriculamVouchers, setCurriculamVouchers, curriculamVouchersRef] = useStateRef([]);
    const [livingVouchers, setLivingVouchers, livingVouchersRef] = useStateRef([]);
    const [distanceLearningVouchers, setDistanceLearningVouchers, distanceLearningVouchersRef] = useStateRef([]);


    const [specialProductItem, setSpecialProductItem, specialProductItemRef] = useStateRef();
    const [livingProductItem, setLivingProductItem, livingProductItemRef] = useStateRef();
    const [nonLivingProductItem, setNonLivingProductItem, nonLivingProductItemRef] = useStateRef();
    const [orderConfirmPromoTop, setOrderConfirmPromoTop, orderConfirmPromoTopRef] = useStateRef();
    const [errorMessage, setErrorMessage, setErrorMessageRef] = useStateRef();
    const [userType, setUserType, userTypeRef] = useStateRef('');
    const [shipDetailsShow, setShipDetailsShow, shipDetailsShowRef] = useStateRef();
    const profileDetail = useSelector(state => state.getProfileDetails.profileDetails)
    const loaderStatus = useSelector(state => state.getLoaderStatus.loaderStatus)
    const dispatch = useDispatch();
    useEffect(() => {
        if (profileDetail && profileDetail.transient === true) {
            setIsGuestUser(true)
        } else {
            setIsGuestUser(false)
            profileDetail?.userType && setUserType(profileDetail.userType)
        }
    }, [profileDetail])
    useEffect(() => {
        if (window.location.pathname == "/checkout/confirm" || window.location.pathname == "/voucher/confirm") {
            console.log("log in confirmation page loader", loaderStatus);
            console.log("log in confirmation page container", containerObject);
            if (loaderStatus == true) {
                console.log("log in confirmation page loader true");
            } else {
                handleOrderConfirmationPromoTop()
                handleConfirmPage()
            }
        }
    }, [])

    function handleOrderConfirmationPromoTop() {
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/order/order-confirm-promo-top`, {
            method: 'GET',
            headers: new Headers({
                "content-Type": "application/json",
            })
        }).then(res => res.json())
            .then(res => {
                if (res.result == "success") {
                    setOrderConfirmPromoTop(res.targeterResult)
                } else {
                    console.log("Error result ---->>>>")
                }
            })
    }

    function handleConfirmPage() {

        if (window.location.pathname == "/voucher/confirm") {


            setIsRedeem(true);
            // setIsLoading(true);
            fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/redeem/confirm-page`, {
                method: 'GET'
            }).then(res => res.json())
                .then(res => {
                    if (res.result === "success") {
                        setIsLoading(false);
                        var parsedResponse = JSON.parse(res.response);
                        var response = parsedResponse.response
                        setRedeemOrderConfirmationDetails(response)
                        if (redeemOrderConfirmationDetailsRef.current && redeemOrderConfirmationDetailsRef.current.productDetail) {
                            setCurriculamVouchers(redeemOrderConfirmationDetailsRef.current.productDetail.curriculum);
                            setLivingVouchers(redeemOrderConfirmationDetailsRef.current.productDetail.living);
                            setDistanceLearningVouchers(redeemOrderConfirmationDetailsRef.current.productDetail.distanceLearning);
                        }

                    } else {
                        setIsLoading(false);
                        const error = res._ERROR_MESSAGE_;

                    }
                })
        }
        if (window.location.pathname == "/checkout/confirm") {
            setIsRedeem(false);
            // setIsLoading(true);
            fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/checkout/order-confirm`, {
                method: 'GET'
            }).then(res => res.json())
                .then(res => {
                    if (res.result === "success") {
                        setIsLoading(false);
                        var response = JSON.parse(res.response);
                        setOrderConfirmationDetails(response.response)
                        orderConfirmationDetailsRef.current && orderConfirmationDetailsRef.current.paymentAddressMap && setPaymentAddressMap(orderConfirmationDetailsRef.current.paymentAddressMap)
                        orderConfirmationDetailsRef.current && orderConfirmationDetailsRef.current.shippingAddressMap && setShippingAddressMap(orderConfirmationDetailsRef.current.shippingAddressMap)

                        if (response.response.dataLayerObject?.dataLayerJson) {
                            console.log('/checkout/confirm fired -- ', response.response.dataLayerObject.dataLayerJson)
                            window.dataLayer = window.dataLayer || []
                            window.dataLayer.push(response.response.dataLayerObject.dataLayerJson)
                        }
                        if (response?.response?.dataLayerObject?.cart_rts_details) {
                            window.dataLayer = window.dataLayer || []
                            window.dataLayer.push(response?.response?.dataLayerObject?.cart_rts_details)
                        }

                        console.log('/checkout/confirm fired -- ');
						handleOrderConfirmDataLayer();
                        handleBVTracking(res);
                        HandlePepperJam();
                        handleHeapTracking();
                        handleSendInBlue();
                        // handleSiteSpec();
                        handleMonetate()
                        handleCustomPixelTag();                        
                    } else {
                        setIsLoading(false);
                        const error = res._ERROR_MESSAGE_;

                    }
                })
        }
    }
    //get call for order confirmation details
    // useEffect(() => {


    //     if (window.location.pathname == "/checkout/confirm") {
    //         setIsRedeem(false);
    //         // setIsLoading(true);
    //         fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/checkout/order-confirm`, {
    //             method: 'GET'
    //         }).then(res => res.json())
    //             .then(res => {
    //                 if (res.result === "success") {
    //                     setIsLoading(false);
    //                     var response = JSON.parse(res.response);
    //                     setOrderConfirmationDetails(response.response)
    //                     orderConfirmationDetailsRef.current && orderConfirmationDetailsRef.current.paymentAddressMap && setPaymentAddressMap(orderConfirmationDetailsRef.current.paymentAddressMap)
    //                     orderConfirmationDetailsRef.current && orderConfirmationDetailsRef.current.shippingAddressMap && setShippingAddressMap(orderConfirmationDetailsRef.current.shippingAddressMap)

    //                     if (response.response.dataLayerObject?.dataLayerJson) {
    //                         console.log('/checkout/confirm fired -- ',response.response.dataLayerObject.dataLayerJson)
    //                         window.dataLayer = window.dataLayer || []
    //                         window.dataLayer.push(response.response.dataLayerObject.dataLayerJson)
    //                     }
    //                     if (response?.response?.dataLayerObject?.cart_rts_details) {
    //                         window.dataLayer = window.dataLayer || []
    //                         window.dataLayer.push(response?.response?.dataLayerObject?.cart_rts_details)
    //                     }

    //                     console.log('/checkout/confirm fired -- ')
    //                     handleBVTracking();
    //                     HandlePepperJam();
    //                     handleHeapTracking();
    //                     handleSendInBlue();
    //                     handleSiteSpec();
    //                     handleOrderConfirmDataLayer()
    //                 } else {
    //                     setIsLoading(false);
    //                     const error = res._ERROR_MESSAGE_;

    //                 }
    //             })
    //     }
    //     if (window.location.pathname == "/voucher/confirm") {
    //         setIsRedeem(true);
    //         // setIsLoading(true);
    //         fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/redeem/confirm-page`, {
    //             method: 'GET'
    //         }).then(res => res.json())
    //             .then(res => {
    //                 if (res.result === "success") {
    //                     setIsLoading(false);
    //                     var parsedResponse = JSON.parse(res.response);
    //                     var response = parsedResponse.response
    //                     setRedeemOrderConfirmationDetails(response)
    //                     if (redeemOrderConfirmationDetailsRef.current && redeemOrderConfirmationDetailsRef.current.productDetail) {
    //                         setCurriculamVouchers(redeemOrderConfirmationDetailsRef.current.productDetail.curriculum);
    //                         setLivingVouchers(redeemOrderConfirmationDetailsRef.current.productDetail.living);
    //                         setDistanceLearningVouchers(redeemOrderConfirmationDetailsRef.current.productDetail.distanceLearning);
    //                     }

    //                 } else {
    //                     setIsLoading(false);
    //                     const error = res._ERROR_MESSAGE_;

    //                 }
    //             })
    //     }
    // }, [])

    var specialProduct = []
    var livingProduct = []
    var nonLivingProduct = []

    //set the products in respective state
    useEffect(() => {

        if (orderConfirmationDetailsRef.current) {



            // special product
            orderConfirmationDetailsRef.current?.dropShipItems ? specialProduct.push(orderConfirmationDetailsRef.current.dropShipItems) : '';
            orderConfirmationDetailsRef.current?.groundOnlyItems ? specialProduct.push(orderConfirmationDetailsRef.current.groundOnlyItems) : '';
            orderConfirmationDetailsRef.current?.softGoodsItems ? specialProduct.push(orderConfirmationDetailsRef.current.softGoodsItems) : '';
            orderConfirmationDetailsRef.current?.backOrderLivingMaterialItems ? specialProduct.push(orderConfirmationDetailsRef.current.backOrderLivingMaterialItems) : '';
            orderConfirmationDetailsRef.current?.rtsProductItems ? specialProduct.push(orderConfirmationDetailsRef.current.rtsProductItems) : '';

            // living product
            orderConfirmationDetailsRef.current?.livingMaterialItems ? livingProduct.push(orderConfirmationDetailsRef.current.livingMaterialItems) : '';
            orderConfirmationDetailsRef.current?.specialLivingMaterialItems ? livingProduct.push(orderConfirmationDetailsRef.current.specialLivingMaterialItems) : '';

            // non-living product
            orderConfirmationDetailsRef.current?.nonLivingCategoryItems ? nonLivingProduct.push(orderConfirmationDetailsRef.current.nonLivingCategoryItems) : '';
        }
        if (specialProduct.length > 0) {
            setSpecialProductItem(specialProduct)
        }
        if (livingProduct.length > 0) {
            setLivingProductItem(livingProduct)
        }
        if (nonLivingProduct.length > 0) {
            setNonLivingProductItem(nonLivingProduct)
        }

        if (orderConfirmationDetailsRef.current) {
            const details = orderConfirmationDetailsRef.current;

            const shouldShowRow =
                details.dropShipItems?.length > 0 ||
                details.groundOnlyItems?.length > 0 ||
                (
                    details.softGoodsItems?.length > 0 &&
                    (details.groundOnlyItems?.length > 0 ||
                        details.dropShipItems?.length > 0 ||
                        details.backOrderLivingMaterialItems?.length > 0 ||
                        details.rtsProductItems?.length > 0 ||
                        details.livingMaterialItems?.length > 0 ||
                        details.specialLivingMaterialItems?.length > 0 ||
                        details.nonLivingCategoryItems?.length > 0
                    )
                ) ||
                details.backOrderLivingMaterialItems?.length > 0 ||
                details.rtsProductItems?.length > 0 ||
                details.livingMaterialItems?.length > 0 ||
                details.specialLivingMaterialItems?.length > 0 ||
                details.nonLivingCategoryItems?.length > 0;
            setShipDetailsShow(shouldShowRow);
        }


    }, [orderConfirmationDetailsRef.current])

    const toggleCheckbox = () => {
        setIsChecked(!isChecked);
    };

    function handleSiteSpec() {
        console.log("handleSiteSpec for orderConfirmation fired");
        var orderItems = orderConfirmationDetailsRef.current && orderConfirmationDetailsRef.current.order_Items;
        if (orderItems) {
            let productList = [];
            orderItems.map((oneItems) => {
                let categoryList = []
                let category = JSON.parse(oneItems?.dataLayer_obj)
                const categoryList1 = [category["dataLayer_obj.productSubCat1"] && category["dataLayer_obj.productSubCat1"], category["dataLayer_obj.productSubCat2"] && category["dataLayer_obj.productSubCat2"], category["dataLayer_obj.productSubCat3"] && category["dataLayer_obj.productSubCat3"], category["dataLayer_obj.productSubCat4"] && category["dataLayer_obj.productSubCat4"]];

                categoryList = categoryList1;
                const productMapDuplicate = {
                    "productId": oneItems?.productId,
                    "category": categoryList
                }
                let productMap = productMapDuplicate;
                productList.push(productMap)

            })
            const page = {
                "type": "confirmation",
                'orderTotal': handleRemove$FromPrice(orderConfirmationDetailsRef?.current?.total), 
                "products": productList
            }
            const order_payload = {
                'type': 'page-view', 
                "page": page
            }
            window.ssRecsInfo = window.ssRecsInfo || {}
            window.ssRecsInfo = order_payload
            window.dispatchEvent(new CustomEvent("sitespect-user-action", { 'detail': order_payload }))
        }

    }

    function handleMonetate() {
        console.log("handleMonetate OrderConfirmation fired");
        var orderConfirmationDetails = orderConfirmationDetailsRef.current;
        var orderItems = orderConfirmationDetails && orderConfirmationDetails.order_Items;
    
        if (orderItems) {
            console.log("Monetate Order Items ::::: ", orderConfirmationDetails);
    
            var purchaseId = orderConfirmationDetails?.webOrderId;
            var currency = orderConfirmationDetails?.dataLayerObject?.dataLayerJson?.currency_code || "USD";


            window.monetateQ = window.monetateQ || [];

            //Setting page type
            // window.monetateQ.push(["setPageType","Purchase"]);
    
            //Building purchase rows from order items
            var purchaseRows = orderItems.map((oneItem) => ({
                purchaseId: purchaseId,
                productId: oneItem?.productId,
                quantity: oneItem?.quantity,
                unitPrice: oneItem?.price,
                currency: currency
            }));
            console.log("Monetate purchaseRows :::: ", purchaseRows);

            // window.monetateQ.push(["addPurchaseRows", purchaseRows]);
            dispatch(monetateDetailsAction({addPurchaseRows : ["addPurchaseRows", purchaseRows],}))		

            //Track data — always last (Which pushes data to monetate)
            // window.monetateQ.push(["trackData"]);
            console.log("Monetate object ", window.monetateQ);
        }
    }

    function handleOrderConfirmDataLayer() {
        var order_items = orderConfirmationDetailsRef.current && orderConfirmationDetailsRef.current.order_Items;
        let productList = [];
        var orderId = "";
        var subtotal = "";
        var shippingTotal = "";
        var discountAmt = "";
        var coupon = "";
        if (orderConfirmationDetailsRef.current?.lastOrderId) {
            orderId = orderConfirmationDetailsRef.current.lastOrderId;
        }
        if (orderConfirmationDetailsRef.current?.cartTotal) {
            subtotal = handleRemove$ConvertToNumber(orderConfirmationDetailsRef.current.cartTotal);
            console.log('subtotal...', subtotal);

        }
        if (orderConfirmationDetailsRef.current?.shippingTotal) {
            shippingTotal = handleRemove$ConvertToNumber(orderConfirmationDetailsRef.current.shippingTotal);
            console.log('shippingTotal...', shippingTotal);
        }
        if (orderConfirmationDetailsRef.current?.discountAmount) {
            discountAmt = handleRemove$ConvertToNumber(orderConfirmationDetailsRef.current.discountAmount);
            console.log('discountAmt...', discountAmt);
        }
        if (orderConfirmationDetailsRef.current?.coupon) {
            coupon = orderConfirmationDetailsRef.current.coupon;
        }
        order_items.map((oneItem) => {
            let oneMap = {
                "brand": "",
                "item_category": oneItem.categories,
                "item_id": oneItem.productId,
                "item_name": oneItem.name,
                "item_variant": "",
                "price": oneItem.price,
                "quantity": oneItem.quantity
            }
            productList.push(oneMap);
        });

        let purchaseObject = {
            "affiliation": "",
            "coupon": coupon ? coupon : "",
            "currency": "USD",
            "discount": discountAmt ? discountAmt : "",
            "items": productList ? productList : "",
            "order_id": orderId ? orderId : "",
            "pageName": "Order Confirmation",
            "pageType": "checkout-confirm",
            "shipping": shippingTotal ? shippingTotal : "",
            "tax": orderConfirmationDetailsRef.current?.tax && orderConfirmationDetailsRef.current?.tax != "Exempt" ? handleRemove$ConvertToNumber(orderConfirmationDetailsRef.current?.tax) : "0.0",
            "transaction_id": orderConfirmationDetailsRef.current?.webOrderId ? orderConfirmationDetailsRef.current?.webOrderId : "",
            "value": subtotal ? subtotal : ""
        }
        let ecommerceData = {
            "purchase": purchaseObject
        }
        let ecommerce = {
            "event": "purchase",
            "ecommerce": ecommerceData
        }

        window.dataLayer = window.dataLayer || []
        window.dataLayer.push(ecommerce)
    }

    function handleCustomPixelTag() {
        var revenue = handleRemove$FromPrice(orderConfirmationDetailsRef.current.cartTotal);
        var currency = "USD";
        var orderId = orderConfirmationDetailsRef.current?.webOrderId ? orderConfirmationDetailsRef.current?.webOrderId : "";
        let src = `https://insight.adsrvr.org/track/pxl/?adv=4xkoclj&ct=0:aiuuthh&fmt=3&v=${revenue}&vf=${currency}&orderid=${orderId}`
        var customPixel_html = `<img height="1" width="1" style="border-style:none;" alt="" src='${src}'/>`
        document.getElementById('customPixelTrackingContainer').innerHTML = customPixel_html;
    }

    function handleSendInBlue() {
        let eventType = "order_completed"
        let siteUrl = (`${window.location.protocol}//${window.location.hostname}`);
        console.log("handleSendInBlue fired", profileDetail);
        var properties = {
            "email": profileDetail?.email ? profileDetail.email : "",
            "FIRSTNAME": profileDetail?.firstName ? profileDetail.firstName : "",
            "LASTNAME": profileDetail?.lastName ? profileDetail.lastName : ""
        }
        var order_items = orderConfirmationDetailsRef.current && orderConfirmationDetailsRef.current.order_Items;
        console.log("order_items", order_items);
        let itemsforSib = [];
        order_items.map((oneItem) => {
            let oneMap = {
                "name": oneItem.name,
                "itemnumber": oneItem.productId,
                "price": handleRemove$FromPrice(oneItem.price),
                "quantity": oneItem.quantity,
                "url": siteUrl + oneItem.url,
                "image": siteUrl + oneItem.imgStr
            }
            itemsforSib.push(oneMap)
        })
        let totalAmtSib = orderConfirmationDetailsRef.current?.total
        let orderId = orderConfirmationDetailsRef.current?.lastOrderId
        var track_event = {
            "id": orderId,
            "data": {
                "total": handleRemove$FromPrice(totalAmtSib),
                "currency": "USD",
                "url": `${siteUrl}/checkout/cart?sib=true`,
                "items": itemsforSib
            }
        }

        console.log("handleSendInBlue properties", properties);
        console.log("handleSendInBlue eventType", eventType);
        console.log("handleSendInBlue track_event", track_event);
        console.log("handleSendInBlue window.sendinblue", window.sendinblue);
        console.log("handleSendInBlue containerObject?.enableAbandonCartEmail", containerObject?.enableAbandonCartEmail);
        console.log("handleSendInBlue  userTypeRef?.current", profileDetail?.userType);


        if (window.sendinblue && containerObject?.enableAbandonCartEmail && containerObject?.enableAbandonCartEmail == "true" && profileDetail?.userType != 3) {
            console.log("handleSendInBlue trigger");
            window.sendinblue.track(eventType, properties, track_event);
        }

    }

    const [showTooltip, setShowTooltip] = useState(false);
    const [showTooltip1, setShowTooltip1] = useState(false);

    const handleMouseEnter = () => {
        setShowTooltip(true);
    };

    const handleMouseLeave = () => {
        setShowTooltip(false);
    };
    const handleMouseEnter1 = () => {
        setShowTooltip1(true);
    };

    const handleMouseLeave1 = () => {
        setShowTooltip1(false);
    };

    function replaceImage(event) {
        event.target.src = DEFAULT_IMAGE_60;
    }

    const clearErrorMsg = (e) => {
        document.getElementById("message-error-div").classList.add("d-none");
        var elems = document.querySelectorAll(".form-control");
        [].forEach.call(elems, function (el) {
            el.classList.remove("has-error");
        });
    }
    const validateRegistration = (key, value) => {
        var searchParam = window.location.search
        var splitedUri = searchParam.split("?")
        switch (key) {
            case "firstName":
                var result = Helper.isEmpty(value.trim())
                var validation = "^[a-zA-Z][a-zA-Z-'\\.\\s]*$";
                var regex = RegExp(validation);
                if (result) {
                    setHasError(true)
                    document.getElementById("message-error-div").classList.remove("d-none")
                    document.getElementById("message-error-div").classList.add("d-block")
                    var emptyFirstName = document.getElementById("firstName_error")
                    emptyFirstName.innerHTML = "First Name is a required field.";
                    document.getElementById("oc_register_firstName").classList.add("form-error")
                } else if (!regex.test(value.trim())) {
                    setHasError(true)
                    document.getElementById("message-error-div").classList.remove("d-none")
                    document.getElementById("message-error-div").classList.add("d-block")
                    document.getElementById("firstName_error").innerHTML = "First Name is invalid";
                    document.getElementById("oc_register_firstName").classList.add("form-error")
                } else {
                    var emptyFirstName = document.getElementById("firstName_error")
                    emptyFirstName.innerHTML = "";
                    document.getElementById("oc_register_firstName").classList.remove("form-error")
                }
                break;
            case "lastName":
                var result = Helper.isEmpty(value.trim())
                var validation = "^[a-zA-Z0-9][A-Za-z0-9-'\\.\\s]*$";
                var regex = RegExp(validation);
                if (result) {
                    setHasError(true)
                    document.getElementById("message-error-div").classList.remove("d-none")
                    document.getElementById("message-error-div").classList.add("d-block")
                    var emptyFirstName = document.getElementById("LastName_error")
                    emptyFirstName.innerHTML = "Last Name is a required field.";
                    document.getElementById("oc_register_lastName").classList.add("form-error")
                } else if (!regex.test(value.trim())) {
                    setHasError(true)
                    document.getElementById("message-error-div").classList.remove("d-none")
                    document.getElementById("message-error-div").classList.add("d-block")
                    document.getElementById("LastName_error").innerHTML = "Last Name is invalid";
                    document.getElementById("oc_register_lastName").classList.add("form-error")
                } else {
                    var emptyLastName = document.getElementById("LastName_error")
                    emptyLastName.innerHTML = "";
                    document.getElementById("oc_register_lastName").classList.remove("form-error")
                }
                break;
            case "email":
                var result = Helper.isEmpty(value.trim())
                var validation = "^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9-]+\\.)+[A-Za-z]{2,6}$";
                var regex = RegExp(validation);
                if (result) {
                    setHasError(true)
                    document.getElementById("message-error-div").classList.remove("d-none")
                    document.getElementById("message-error-div").classList.add("d-block")
                    var emptyErrorMessage = document.getElementById("email_error")
                    emptyErrorMessage.innerHTML = "Email Address is a required field.";
                    document.getElementById("oc_register_email").classList.add("form-error")
                } else if (!regex.test(value.trim())) {
                    setHasError(true)
                    document.getElementById("message-error-div").classList.remove("d-none")
                    document.getElementById("message-error-div").classList.add("d-block")
                    document.getElementById("email_error").innerHTML = "The email address does not appear to be valid. Please use the format mailto:name@domain.xxx.";
                    document.getElementById("oc_register_email").classList.add("form-error")
                } else {
                    var emptyEmail = document.getElementById("email_error")
                    emptyEmail.innerHTML = "";
                    document.getElementById("oc_register_email").classList.remove("form-error")
                }
                break;

            case "password":
                var result = Helper.isEmpty(value)
                var validation = /.{6,}/
                var regex = RegExp(validation);
                if (result) {
                    setHasError(true)
                    document.getElementById("message-error-div").classList.remove("d-none")
                    document.getElementById("message-error-div").classList.add("d-block")
                    var emptyFirstName = document.getElementById("password_error")
                    emptyFirstName.innerHTML = "Password is a required field.";
                    document.getElementById("oc_register_password").classList.add("form-error")
                } else if (!regex.test(value)) {
                    setHasError(true)
                    document.getElementById("message-error-div").classList.remove("d-none")
                    document.getElementById("message-error-div").classList.add("d-block")
                    document.getElementById("password_error").innerHTML = "Password is invalid";
                    document.getElementById("oc_register_password").classList.add("form-error")
                } else {
                    var emptyPassword = document.getElementById("password_error")
                    emptyPassword.innerHTML = "";
                    document.getElementById("oc_register_password").classList.remove("form-error")
                }
                break;
            case "custType":
                if (splitedUri[1] != "intl=true") {
                    var result = Helper.isEmpty(value);
                    if (result) {
                        setHasError(true)
                        document.getElementById("message-error-div").classList.remove("d-none")
                        document.getElementById("message-error-div").classList.add("d-block")
                        document.getElementById("custType_error").innerHTML = "Please choose an option to continue as a new customer."
                    } else {
                        var emptyCustType = document.getElementById("custType_error")
                        emptyCustType.innerHTML = "";
                    }
                } else {
                    var emptyCustType = document.getElementById("custType_error")
                    emptyCustType.innerHTML = "";
                }
                break;
            default:
        }
    }

    function handleRegister(event) {
        event.preventDefault();
        clearErrorMsg();
        setHasError(false)
        var searchParam = window.location.search
        var splitedUri = searchParam.split("?")
        var actionUrl = event.target.getAttribute('action');
        var formData = new FormData(event.target);
        const formValue = Object.fromEntries(formData.entries());
        formValue["optIn"] = isChecked.toString();
        if (!("custType" in formValue)) {
            if (splitedUri[1] == "intl=true") {
                formValue["custType"] = "international";
            } else {
                formValue["custType"] = null;
            }
        }
        // formValue["previousUrl"] = redirectURL;
        Object.entries(formValue).map(([key, value], keyIndex) => {
            validateRegistration(key, value)
        })
        if (!hasErrorRef.current) {
            setHasError(false)
            // setIsLoading(true)
            fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/${actionUrl}`, {
                method: 'POST',
                headers: new Headers({
                    "content-Type": "application/json",
                }),
                body: JSON.stringify(formValue)
            }).then(res => res.json())
                .then(res => {
                    var response = res?.response && JSON.parse(res.response);
                    if (res.result === "success" && response.status === "success") {
                        setIsLoading(false)
                        // var redirectPageMap = res && res.response;
                        // var redirectPage = redirectPageMap && redirectPageMap.redirectPage;
                        var messageFlag = 'true'
                        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/landing-message-success/${messageFlag}`, {
                            method: 'GET'
                        }).then(res => res.json())
                            .then(res => {
                                if (res.result === "success") {
                                    var response1 = (JSON.parse(res.response)).response
                                    if (document.getElementById('exampleRadios1').checked == true) {
                                        const isRegisterFromOrderConfirm = true;
                                        history.push('/account/school', isRegisterFromOrderConfirm)
                                    } else if (document.getElementById('exampleRadios2').checked == true) {
                                        history.push('/checkout/confirm?create=true', response1)
                                    } else {
                                        console.log('No redirection occur')
                                    }
                                }
                            })

                    } else {
                        setIsLoading(false)
                        response = response && response.response && JSON.parse(response.response);
                        response = response.errors;
                        response.map((error, key) => {
                            setErrorMessage(error);
                        })
                        document.getElementById("message-error-div").classList.remove("d-none")
                        document.getElementById("message-error-div").classList.add("d-block")
                        var resultExisitingError = document.getElementById("resultExisitingError")
                        var modifiedUrl = setErrorMessageRef.current.replace(".jsp", "");
                        resultExisitingError.innerHTML = modifiedUrl;
                    }
                })
        }
    }

    function handleHeapTracking() {
        console.log('emailForHeap...', profileDetail?.email);
        if (!containerObject.heapTrackOrderId || (containerObject?.heapTrackOrderId && orderConfirmationDetailsRef.current?.lastOrderId && containerObject.heapTrackOrderId != orderConfirmationDetailsRef.current?.lastOrderId)) {

            var email = "";
            var orderId = "";
            var subtotal = "";
            var orderTotal = "";
            var shippingTotal = "";
            var discountAmt = "";
            var coupon = "";
            var totalCommerceItemCount = "";
            var product_ids = [];
            var product_prices = [];
            var product_qtys = [];
            var product_names = [];
            var product_categories = [];
            var order_items = orderConfirmationDetailsRef.current && orderConfirmationDetailsRef.current.order_Items;
            order_items.map((oneItem) => {
                product_ids.push(oneItem.productId)
                product_qtys.push(oneItem.quantity)
                product_prices.push(oneItem.price)
                product_names.push(oneItem.name)
                product_categories.push(oneItem.categories)
            })

            if (profileDetail?.email) {
                email = profileDetail?.email ? profileDetail.email : '';

            }
            if (orderConfirmationDetailsRef.current?.lastOrderId) {
                orderId = orderConfirmationDetailsRef.current.lastOrderId;
            }
            if (orderConfirmationDetailsRef.current?.cartTotal) {
                subtotal = handleRemove$FromPrice(orderConfirmationDetailsRef.current.cartTotal);
                console.log('subtotal...', subtotal);

            }
            if (orderConfirmationDetailsRef.current?.total) {
                orderTotal = handleRemove$FromPrice(orderConfirmationDetailsRef.current.total);
                console.log('orderTotal...', orderTotal);
            }

            if (orderConfirmationDetailsRef.current?.shippingTotal) {
                shippingTotal = handleRemove$FromPrice(orderConfirmationDetailsRef.current.shippingTotal);
                console.log('shippingTotal...', shippingTotal);
            }
            if (orderConfirmationDetailsRef.current?.discountAmount) {
                discountAmt = handleRemove$FromPrice(orderConfirmationDetailsRef.current.discountAmount);
                console.log('discountAmt...', discountAmt);
            }
            if (orderConfirmationDetailsRef.current?.coupon) {
                coupon = orderConfirmationDetailsRef.current.coupon;
            }

            if (orderConfirmationDetailsRef.current?.dataLayerObject?.dataLayerJson?.cart_total_items) {
                totalCommerceItemCount = orderConfirmationDetailsRef.current.dataLayerObject.dataLayerJson.cart_total_items;
            }


            if (product_ids != null && product_ids != "undefined") {
                for (var i = 0; i < product_ids.length; i++) {
                    var lineItemdiscAmt = "";
                    var lineItemcoupon = "";
                    var orderDisc = "";
                    var discountedArr = order_items[i].discountable ? order_items[i].discountable : '';
                    if (discountedArr && discountedArr == 'true') {
                        lineItemdiscAmt = discountAmt;
                        lineItemcoupon = coupon;
                    }
                    window.heap.track('Purchase', { email: email, order_id: orderId, product_id: product_ids[i], name: product_names[i], category: product_categories[i], variant: "", price: product_prices[i], quantity: product_qtys[i], discount: lineItemdiscAmt, discount_code: lineItemcoupon, order_count: totalCommerceItemCount });

                }
                if (i == product_ids.length) {
                    window.heap.track('Order', { email: email, order_id: orderId, subtotal: subtotal, total: orderTotal, shipping: shippingTotal, discount: discountAmt, discount_code: coupon, order_count: totalCommerceItemCount });
                }
            }
            var actionUrl = "api/rest/cb/checkout/set-heap-track-id";
            var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
            var res = Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({ heapTrackOrderId: orderConfirmationDetailsRef.current?.lastOrderId }))
        }

    }

    function handleBVTracking(result) {
        console.log("handleBVTracking res",result);
        let url = result?.bvUrl??"https://apps.bazaarvoice.com/deployments/carolina/main_site/production/en_US/bv.js";
        if (url) {
            const head = document.querySelector("#bazaarUrl");
            const script = document.createElement("script");
            script.setAttribute("src", url);
            head.appendChild(script);
        }
        window.bvCallback = function (BV) {
            BV.pixel.trackTransaction({
                "currency": "USD",
                "orderId": orderConfirmationDetailsRef.current.lastOrderId,
                "total": orderConfirmationDetailsRef.current.cartTotal && orderConfirmationDetailsRef.current.cartTotal.includes("$") ? orderConfirmationDetailsRef.current.cartTotal.replace("$", "") : orderConfirmationDetailsRef.current.cartTotal,
                "items": handleOrderItem(),
                "email": profileDetail.email ? profileDetail.email : shippingAddressMapRef.current?.recipientEmail ? shippingAddressMapRef.current.recipientEmail : ""
            });
        };

        function handleOrderItem() {
            let listDetail = []
            var order_items = orderConfirmationDetailsRef.current && orderConfirmationDetailsRef.current.order_Items;
            order_items.map((oneItem) => {
                let oneData = {
                    "sku": oneItem.productId,
                    "quantity": oneItem.quantity,
                    "price": oneItem.price
                };
                listDetail.push(oneData);
            })
            return listDetail;
        }
    }

    function HandlePepperJam() {
        var cookieData = getCookie(clickIdCookieName);
        function getCookie(cookie) {
            var cookieName = cookie + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var cookieArray = decodedCookie.split(';');
            for (var i = 0; i < cookieArray.length; i++) {

                var c = cookieArray[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(cookieName) == 0) {
                    return c.substring(cookieName.length, c.length);
                }
            }
            return "";
        }




        if (cookieData != "") {
            var order_items = orderConfirmationDetailsRef.current && orderConfirmationDetailsRef.current.order_Items;

            var order_id = orderConfirmationDetailsRef.current && orderConfirmationDetailsRef.current.lastOrderId;
            var new_to_file = orderConfirmationDetailsRef.current && orderConfirmationDetailsRef.current.newToFile ? orderConfirmationDetailsRef.current.newToFile : "0";
            var coupons = orderConfirmationDetailsRef.current && orderConfirmationDetailsRef.current.coupon;
            var transaction_type = 1;

            function pepperjam_pixel(order_id, order_items, new_to_file, transaction_type) {
                var pixel_html = '';
                var integration = 'DYNAMIC';
                var program_id = "9235";

                var click_ids = [];
                var clickIdData;
                if (cookieData != "") {
                    clickIdData = JSON.parse(cookieData);
                    clickIdData.map((clickId) => {
                        click_ids.push(clickId.id);
                    })
                }

                if (order_id && order_items) {
                    order_items.map((order_item, i) => {
                        const count = i + 1;
                        pixel_html += `&ITEM_ID${count}=${order_item.productId}&ITEM_PRICE${count}=${order_item?.priceNew ? order_item.priceNew : order_item.price ? order_item.price : ''}&QUANTITY${count}=${order_item.quantity}`
                    })

                    if (pixel_html) {
                        let src = `https://t.pepperjamnetwork.com/track?INT=${integration}&PROGRAM_ID=${program_id}&ORDER_ID=${order_id}&CLICK_ID=${click_ids.join()}&COUPON=${coupons ? coupons : ''}&NEW_TO_FILE=${new_to_file}&TYPE=${transaction_type}&CURRENCY=USD${pixel_html}`

                        pixel_html = `<iframe id="pepperjamIframe" src=${src}
                              "frameborder"="0"></iframe>`;
                        document.getElementById('pepperjamContainer').innerHTML = pixel_html;
                        console.log('pepperjam script called...');
                    }
                }


                document.cookie = clickIdCookieName
                    + "="
                    + JSON.stringify(3)
                    + ";max-age=0"
                    + ";path=/"; //Delete cookie after pixel data is sent in order confirmation
            }
            pepperjam_pixel(order_id, order_items, new_to_file, transaction_type);
        }
    }

    const handleRemove$FromPrice = (price) => {
        if (price.includes('$'))
            return price.replace('$', '');
        else
            return price;
    }

    const handleRemove$ConvertToNumber = (priceString) => {
    	
    	console.log('Before...', priceString);
    	
    	if (!priceString || typeof priceString !== 'string') return 0;

        // Remove currency symbols, commas, and any non-numeric characters except the decimal point
        const replacedString = priceString.replace(/[^0-9.]/g, '');

        // Parse the string to a float
        const price = parseFloat(replacedString);

        console.log('after...', price);
        // Return 0 if parsing fails
        return isNaN(price) ? 0 : price;
        
    }

    return (
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row`}>
            {isLoading ? <Loader /> : ""}
            <div className={`p-0 c-account-page c-confirm-page justify-content-center c-order-content ${isRedeemRef.current ? 'voucher-confirm' : ''}`}>
                <div className="col-12 col-md-11">

                    <div className="row align-items-center justify-content-between mb-2">
                        <div className="col-md-11">
                        </div>
                        <div className="col-12 col-md-1 d-none d-lg-block">
                            <button className="btn btn-light c-print-btn text-end " type="button" onClick={() => window.print()}>
                                {/* <i className="bi bi-printer-fill" aria-hidden="true"></i> */}
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-printer-fill" viewBox="0 0 16 16">
                                    <path d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1" />
                                    <path d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
                                </svg>
                                Print
                            </button>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-md-12">
                            <div className="row">
                                <div className="col-12 col-md-6 text-left">
                                    <h1 className="c-account-heading">
                                        {orderConfirmationDetailsRef.current?.ThanksMsg ? orderConfirmationDetailsRef.current.ThanksMsg : redeemOrderConfirmationDetailsRef.current?.thankYouMsg ? redeemOrderConfirmationDetailsRef.current.thankYouMsg : ""}
                                    </h1>

                                    <h1 className="c-account-heading">
                                        <span className="orderid">{orderConfirmationDetailsRef.current?.webOrderId ? <>Your confirmation number is {orderConfirmationDetailsRef.current.webOrderId}.</> : ""}</span>
                                    </h1>

                                </div>
                                <div className="col-12 col-md-6 text-end voucher-confirm-btn">
                                    <Link to="/" className='c-order-btn-padding'>
                                        <button type="submit" className="btn btn-secondary block">
                                            Continue Shopping
                                        </button>
                                    </Link>
                                    <Link to={{ pathname: profileDetail && profileDetail.transient === true ? '/account/login' : orderConfirmationDetailsRef.current?.myAccountUrl ? orderConfirmationDetailsRef.current.myAccountUrl.substr(0, orderConfirmationDetailsRef.current.myAccountUrl.indexOf(".")) : redeemOrderConfirmationDetailsRef.current?.myAccountURL ? redeemOrderConfirmationDetailsRef.current.myAccountURL.substr(0, redeemOrderConfirmationDetailsRef.current.myAccountURL.indexOf(".")) : "", state: { previousUrl: '/checkout/confirm' } }} className=''>
                                        <button type="submit" className="btn btn-secondary block ml-2" >
                                            My Account
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    {isRedeemRef.current ?
                        <p className='c-regular-text mt-5 mb-5 fst-italic'>
                            Your request has been processed and you will receive an email confirmation shortly. If you have any questions about your voucher redemption, please call us at 1-800-334-5551.
                        </p>
                        :
                        <p className="c-regular-text mt-4 mb-4" dangerouslySetInnerHTML={{ __html: orderConfirmationDetailsRef.current?.confirmMsg }}>
                        </p>
                    }

                    {isGuestUserRef.current && isGuestUserRef.current === true && !isRedeem ?
                        <div className="row justify-content-center">
                            <div className="col-md-10">
                                <div className="c-confirm-register">
                                    <div id="message-error-div" className="message message-red form-error-messages col-md-12 mx-auto">
                                        <div className="col-12">
                                            <div id='resultExisitingError' style={{ color: "black" }} dangerouslySetInnerHTML={{ __html: setErrorMessageRef.current }}></div>
                                            <div id='firstName_error' style={{ color: "black" }}></div>
                                            <div id='LastName_error' style={{ color: "black" }}></div>
                                            <div id='email_error' style={{ color: "black" }} ></div>
                                            <div id='password_error' style={{ color: "black" }}></div>
                                            <div id='custType_error' style={{ color: "black" }}></div>
                                        </div>
                                    </div>
                                    <div id="err" className="ml-5 mr-4 message message-red form-error-messages">
                                    </div>
                                    <form method="post" autocomplete="off" action="choose-account-type" id="oc-register-form" className="c-account-page" onSubmit={handleRegister}>
                                        <div className="text-left mb-4">
                                            <p className="c-confirm-heading"><i className="bi bi-check-lg"></i>
                                                Don't Leave Without Creating a Login-You're Almost There!
                                            </p>
                                            <p className="c-confirm-heading">
                                                Enjoy the benefits of applicable discounts, faster checkout, &amp; so much more!
                                            </p>
                                        </div>

                                        <div className="row">
                                            <div className="col-12 col-md-4">
                                                <label className="form-label" for="firstName">First Name</label>
                                                <input maxlength="19" name="firstName" id="oc_register_firstName" type="text" className="form-control" />
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <label className="form-label" for="email">Email</label>
                                                <input maxlength="256" name="email" id="oc_register_email" type="text" className="form-control c-read-only" defaultValue={shippingAddressMapRef.current?.recipientEmail ? shippingAddressMapRef.current.recipientEmail : ""} autocomplete="new-password" />
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <div className="form-check c-register-check">
                                                    <input id="gridCheck" type="checkbox" className="form-check-input" onChange={toggleCheckbox} />
                                                    <label className="form-check-label" for="gridCheck">
                                                        <strong>Yes</strong>, subscribe me to your newsletter.<br />You may opt out any time. <a href="/help/terms-of-use" target="_blank">Terms</a> and <a href="/help/privacy-and-security" target="_blank">Privacy Policy</a>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row mb-5">
                                            <div className="col-md-4">
                                                <label className="form-label" for="lastName">Last Name</label>
                                                <input maxlength="19" name="lastName" id="oc_register_lastName" type="text" className="form-control" />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label" for="password">Password</label>
                                                <div className="c-input-tooltip c-input-password">
                                                    <input name="password" id="oc_register_password" type={isRevealPwd ? "text" : "password"} className="form-control create-account-password" value={pwd} onChange={e => setPwd(e.target.value)} autocomplete="new-password" />
                                                    <Link className="c-register-passShow" style={{ textDecoration: 'none', position: 'absolute' }} id="show-password-field" onClick={() => setIsRevealPwd(prevState => !prevState)}>
                                                        {isRevealPwd ? 'HIDE' : 'SHOW'}
                                                    </Link>
                                                    {/* <span className="c-tooltip" data-bs-html="true" data-bs-toggle="tooltip" aria-label="Passwords must be at least 6 characters long."><i className="bi bi-question-circle-fill"></i></span> */}
                                                    <span id='password-tooltip' className="c-tooltip" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} >
                                                        <i className="bi bi-question-circle-fill"></i>
                                                        {showTooltip && (
                                                            <div style={{
                                                                position: 'absolute', top: '-69px', left: '-80px', zIndex: '1', width: '200px', padding: '0.875rem',
                                                                backgroundColor: '#fbf3bf', border: '0.063rem solid #ccc', boxShadow: '0 0 0.625rem #ccc', lineHeight: '1.125rem',
                                                                letterSpacing: '0', color: '#333', borderRadius: '0.313rem', textAlign: 'left',
                                                                fontSize: '0.75rem', fontWeight: '400'
                                                            }}>
                                                                <div style={{
                                                                    position: 'absolute', top: '65px', left: '50%', marginLeft: '-13px', width: '0', height: '0',
                                                                    borderLeft: '5px solid transparent', borderRight: '5px solid transparent', borderTop: '7px solid #333',
                                                                }}></div>
                                                                Passwords must be at least 6 characters long.
                                                            </div>
                                                        )}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6  mb-3">
                                                <div className="text-left">
                                                    <p className="text-left c-regular-text">
                                                        Are you ordering on behalf of school or business?
                                                        <span className="c-tooltip m" onMouseEnter={handleMouseEnter1} onMouseLeave={handleMouseLeave1} style={{ position: 'relative' }}>
                                                            <i className="bi bi-question-circle-fill"></i>
                                                            {showTooltip1 && (
                                                                <div style={{
                                                                    position: 'absolute', top: '-185px', left: '-88px', zIndex: '1', width: '200px', padding: '0.875rem',
                                                                    backgroundColor: '#fbf3bf', border: '0.063rem solid #ccc', boxShadow: '0 0 0.625rem #ccc', lineHeight: '1.125rem',
                                                                    letterSpacing: '0', color: '#333', borderRadius: '0.313rem', textAlign: 'left',
                                                                    fontSize: '0.75rem', fontWeight: '400'
                                                                }}>
                                                                    <div style={{
                                                                        position: 'absolute', top: '173px', left: '53%', marginLeft: '-15px', width: '0', height: '0',
                                                                        borderLeft: '5px solid transparent', borderRight: '5px solid transparent', borderTop: '7px solid #333',
                                                                    }}></div>
                                                                    If purchasing for a school or institution, select <strong>yes</strong> to link your online account to your school or institution's corporate account. Please Note: this corporate account must have an existing Net 30 account with carolina.
                                                                </div>
                                                            )}
                                                        </span>
                                                    </p>
                                                </div>
                                                <div className="form-check form-check-inline">
                                                    <input name="custType" id="exampleRadios1" type="radio" value="institution" className="form-check-input" />
                                                    <label className="form-check-label" for="exampleRadios1">Yes</label>
                                                </div>
                                                <div className="form-check form-check-inline">
                                                    <input name="custType" id="exampleRadios2" type="radio" value="personal" className="form-check-input" />
                                                    <label className="form-check-label" for="exampleRadios2">No</label>
                                                </div>
                                            </div>
                                            <div className="col-md-4 d-grid">
                                                <button type="submit" className="btn btn-primary block c-btn-register" >
                                                    Register
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div> : ""}
                    {orderConfirmPromoTopRef.current ?
                        <div className="col-12 mt-4">
                            <div class="order-confirm-targeter" dangerouslySetInnerHTML={{ __html: orderConfirmPromoTopRef.current }}></div>
                        </div> : ''
                    }

                    <div className="row mt-5 mb-3">
                        <div className="col-12 col-md-6 text-left">
                            <div className="c-order-flex">
                                <h1 className="c-account-heading">Order Details</h1>
                                <button type="submit" className={isRedeemRef.current ? "btn btn-secondary block redeem-confirm-print" : "btn btn-secondary block"} onClick={() => window.print()}>
                                    {/* <i className="bi bi-printer-fill" aria-hidden="true"></i> */}
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-printer-fill" viewBox="0 0 16 16">
                                        <path d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1" />
                                        <path d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
                                    </svg> Print</button>
                            </div>
                        </div>
                    </div>


                    <div className="row c-order-confirmation">
                        {orderConfirmationDetailsRef.current?.webOrderId ?
                            <div className="col-md-4">
                                <div className="c-confirm-order-header mb-2">
                                    <h2>ORDER SUMMARY</h2>
                                </div>
                                <p className="c-confirm-billing-address">
                                    Confirmation Number:&nbsp;{orderConfirmationDetailsRef.current?.webOrderId}
                                </p>
                                <p className="c-confirm-billing-address mb-3">
                                    Order Date:&nbsp;{orderConfirmationDetailsRef.current?.submittedDate && Helper.dateFormatter(orderConfirmationDetailsRef.current.submittedDate)}
                                </p>
                                {orderConfirmationDetailsRef.current?.coupon ?
                                    <div className="c-order-summary">
                                        <p class="c-order-label fw-normal">{orderConfirmationDetailsRef.current?.promotionMsg}&nbsp;</p>
                                        <p class="c-order-value fw-normal">{orderConfirmationDetailsRef.current?.coupon}</p>
                                    </div> : ""}
                                <div className="c-order-summary">
                                    <p className="c-order-label fw-normal">Subtotal:</p>
                                    <p className="c-order-value fw-normal">{orderConfirmationDetailsRef.current?.cartTotal}</p>
                                </div>
                                {orderConfirmationDetailsRef.current?.discountAmount ?
                                    <div class="c-order-summary">
                                        <p class="c-order-label fw-normal">{orderConfirmationDetailsRef.current?.promotionDiscountMsg}</p>
                                        <p class="c-order-value fw-normal">-{orderConfirmationDetailsRef.current?.discountAmount}</p>
                                    </div> : ""}

                                <div className="c-order-summary">
                                    <p className="c-order-label fw-normal">Freight &amp; Handling:</p>
                                    {orderConfirmationDetailsRef.current?.nonContractShipping &&
                                        <p className='c-order-value fw-normal'>
                                            <del>{orderConfirmationDetailsRef.current.nonContractShipping}</del>
                                        </p>}
                                    <p className="c-order-value fw-normal">
                                        {orderConfirmationDetailsRef.current?.shippingTotal}
                                    </p>

                                </div>
                                <div className="c-order-summary">
                                    <p className="c-order-label fw-normal">Tax:</p>
                                    <p className="c-order-value fw-normal">
                                        {orderConfirmationDetailsRef.current?.tax}
                                    </p>
                                </div>
                                {orderConfirmationDetailsRef.current?.retailTotal &&
                                    <div className='c-order-summary mb-0'>
                                        <p className='c-order-label'>
                                            Total Retail:
                                        </p>
                                        <p className='c-order-value cart-item-original-price'>
                                            {orderConfirmationDetailsRef.current.retailTotal}
                                        </p>
                                    </div>
                                }



                                <div className={`${orderConfirmationDetailsRef.current?.retailTotal ? "c-order-summary" : "c-order-summary mt-3"}`}>
                                    <p className="c-order-total">
                                        {orderConfirmationDetailsRef.current?.totalTitle ? orderConfirmationDetailsRef.current.totalTitle : orderConfirmationDetailsRef.current?.totalContractTitle ? orderConfirmationDetailsRef.current?.totalContractTitle : ''}
                                    </p>
                                    <p className="c-order-amount">
                                        {orderConfirmationDetailsRef.current?.total ? orderConfirmationDetailsRef.current.total : ""}
                                    </p>
                                </div>
                            </div> : ""}

                        {paymentAddressMapRef.current ?
                            <div className="col-md-4">

                                <div className="c-confirm-order-header mb-2">
                                    <h2>BILLING INFORMATION</h2>
                                </div>
                                {paymentAddressMapRef.current?.creditCardNumberForPaymentDetails ?
                                    <p className="c-confirm-billing-address">
                                        Paid via {paymentAddressMapRef.current && paymentAddressMapRef.current.PaymentType}
                                    </p> :
                                    <p className="c-confirm-billing-address mb-3">
                                        Paid with {paymentAddressMapRef.current && paymentAddressMapRef.current.PaymentType}
                                    </p>}
                                {paymentAddressMapRef.current && paymentAddressMapRef.current.creditCardNumberForPaymentDetails ?
                                    <p className="c-confirm-billing-address">
                                        Number: {<>**** **** **** {paymentAddressMapRef.current.creditCardNumberForPaymentDetails}<br /></>}
                                    </p>
                                    : ""}

                                {paymentAddressMapRef.current && paymentAddressMapRef.current.expirationMonth && paymentAddressMapRef.current.expirationYear ?
                                    <p className="c-confirm-billing-address mb-3">
                                        Expiration Date: {paymentAddressMapRef.current.expirationMonth}/{paymentAddressMapRef.current.expirationYear}
                                    </p>
                                    : ""}
                                {paymentAddressMapRef.current?.cardPoRefNumber ?
                                    <p className="c-confirm-billing-address">
                                        Reference Number: {paymentAddressMapRef.current.cardPoRefNumber}
                                    </p>
                                    : ""}
                                <address>
                                    {paymentAddressMapRef.current?.companyName ? <>{paymentAddressMapRef.current?.companyName}<br /></> : <></>}
                                    {paymentAddressMapRef.current?.address1 ? <>{paymentAddressMapRef.current?.address1}<br /></> : <></>}
                                    {paymentAddressMapRef.current?.address2 ? <>{paymentAddressMapRef.current?.address2}<br /></> : <></>}
                                    {paymentAddressMapRef.current?.city},&nbsp;{paymentAddressMapRef.current?.State}&nbsp;{paymentAddressMapRef.current?.postalCode}
                                </address>
                            </div> : ""}

                        {shippingAddressMapRef.current && shipDetailsShowRef.current &&
                            <div className="col-md-4">
                                <div className="c-confirm-order-header mb-2">
                                    <h2>
                                        SHIPPING INFORMATION
                                    </h2>
                                </div>
                                <p className="c-confirm-billing-address mb-3">
                                    Shipping methods and dates for each item in your order are noted below.
                                </p>
                                {shippingAddressMapRef.current &&
                                    <address>
                                        {shippingAddressMapRef.current?.recipientFirstName}&nbsp;{shippingAddressMapRef.current?.recipientLastName}<br />
                                        {shippingAddressMapRef.current?.companyName ? <>{shippingAddressMapRef.current?.companyName}<br /></> : <></>}
                                        {shippingAddressMapRef.current?.address1 ? <>{shippingAddressMapRef.current?.address1}<br /></> : <></>}
                                        {shippingAddressMapRef.current?.location ? <>{shippingAddressMapRef.current.location}<br /></> : shippingAddressMapRef.current?.address2 ? <>{shippingAddressMapRef.current.address2}<br /></> : ""}
                                        {shippingAddressMapRef.current?.city},&nbsp;{shippingAddressMapRef.current?.State}&nbsp;{shippingAddressMapRef.current?.postalCode}<br />
                                        {shippingAddressMapRef.current?.primaryPhoneNumber && Helper.phoneNumberFormatter(shippingAddressMapRef.current.primaryPhoneNumber)}<br />
                                        {shippingAddressMapRef.current?.recipientEmail ? <>{shippingAddressMapRef.current?.recipientEmail}<br /></> : <></>}
                                    </address>
                                }

                            </div>}

                        {redeemOrderConfirmationDetailsRef.current &&
                            <div className="col-md-4 redeem-review-address">
                                <div className="c-confirm-order-header mb-2">
                                    <h2>
                                        SHIPPING INFORMATION
                                    </h2>
                                </div>
                                <p className="redeem-shipping-msg mb-3 px-md-2 py-2 ">
                                    Shipping methods and dates for each item in your order are noted below.
                                </p>
                                {
                                    redeemOrderConfirmationDetailsRef.current &&
                                    <address className='px-md-2 redeem-shipping-address'>
                                        {redeemOrderConfirmationDetailsRef.current?.firstName}&nbsp;{redeemOrderConfirmationDetailsRef.current?.lastName}<br />
                                        {redeemOrderConfirmationDetailsRef.current?.companyName ? <>{redeemOrderConfirmationDetailsRef.current.companyName}<br /></> : ""}
                                        {redeemOrderConfirmationDetailsRef.current?.address1 ? <>{redeemOrderConfirmationDetailsRef.current.address1}<br /></> : ""}
                                        {redeemOrderConfirmationDetailsRef.current?.address2 ? <>{redeemOrderConfirmationDetailsRef.current.address2}<br /></> : ""}
                                        {redeemOrderConfirmationDetailsRef.current?.city ? <>{redeemOrderConfirmationDetailsRef.current.city}</> : ""},&nbsp;{redeemOrderConfirmationDetailsRef.current?.state ? redeemOrderConfirmationDetailsRef.current.state : ""}&nbsp;{redeemOrderConfirmationDetailsRef.current?.postalCode ? <>{redeemOrderConfirmationDetailsRef.current.postalCode}<br /></> : ""}
                                        {redeemOrderConfirmationDetailsRef.current?.phoneNumber ? <>{redeemOrderConfirmationDetailsRef.current.phoneNumber}<br /></> : ""}
                                        {redeemOrderConfirmationDetailsRef.current?.email ? <>{redeemOrderConfirmationDetailsRef.current.email}<br /></> : ""}
                                    </address>
                                }
                            </div>}

                    </div>

                    <section className="row mt-5 mb-4">
                        <div className="col-md-12">
                            <div className="c-confirm-wrapper mb-4">

                                <div className="row d-none d-md-flex c-confirm-items-header">
                                    <div className="col-12 col-md-6 col-lg-7 py-2">
                                        ITEM INFORMATION
                                    </div>
                                    {orderConfirmationDetailsRef.current ? <>
                                        <div className="col py-2 text-end c-confirm-price-header">
                                            ITEM PRICE
                                        </div>
                                        <div className="col py-2 text-center">
                                            QTY
                                        </div>
                                        <div className="col py-2 text-center text-md-end">
                                            TOTAL
                                        </div>
                                    </> : ""}
                                </div>

                                {/* for specialProductItem */}
                                {specialProductItemRef.current ? specialProductItemRef.current.map((specialProducts) => (
                                    <>
                                        {specialProducts && Object.entries(specialProducts).map(([key, specialItemList], index) => (
                                            <div className="row c-confirm-item-list">
                                                <div className="col-12 col-md-6 col-lg-7 mb-2 mb-md-0">
                                                    <div className="row align-items-center c-confirm-item-desc">
                                                        <div className="col-12 d-md-none">
                                                            <div className="c-confirm-item-header pb-2 mb-2 c-order-title">
                                                                ITEM INFORMATION
                                                            </div>
                                                        </div>

                                                        <div className="col-auto">
                                                            <img onError={replaceImage} src={`${specialItemList?.imagePathForDropShipItem ? specialItemList.imagePathForDropShipItem :
                                                                specialItemList?.imagePathForGroundOnlyItem ? specialItemList.imagePathForGroundOnlyItem :
                                                                    specialItemList?.imagePathForsoftGoodsItem ? specialItemList.imagePathForsoftGoodsItem :
                                                                        specialItemList?.imagePathForBackOrderLivingItem ? specialItemList.imagePathForBackOrderLivingItem :
                                                                            specialItemList?.imagePathForRtsProductitem ? specialItemList.imagePathForRtsProductitem :
                                                                                ""}`} />
                                                        </div>
                                                        <div className="col-8 c-confirm-item-info c-confirm-item-size">
                                                            <span className="fwb text-ellipsis" dangerouslySetInnerHTML={{
                                                                __html: specialItemList?.productDescForDropShipItem ? specialItemList.productDescForDropShipItem :
                                                                    specialItemList?.productDescForGroundOnlyItem ? specialItemList.productDescForGroundOnlyItem :
                                                                        specialItemList?.productDescForsoftGoodsItem ? specialItemList.productDescForsoftGoodsItem :
                                                                            specialItemList?.productDescForBackOrderLivingItem ? specialItemList.productDescForBackOrderLivingItem :
                                                                                specialItemList?.productDescForRtsProductitem ? specialItemList.productDescForRtsProductitem : ""
                                                            }}>
                                                            </span>
                                                            <span>
                                                                #{specialItemList?.itemNumberForDropShipItem ? specialItemList.itemNumberForDropShipItem :
                                                                    specialItemList?.itemNumberForGroundOnlyItem ? specialItemList.itemNumberForGroundOnlyItem :
                                                                        specialItemList?.itemNumberForsoftGoodsItem ? specialItemList.itemNumberForsoftGoodsItem :
                                                                            specialItemList?.itemNumberForBackOrderLivingItem ? specialItemList.itemNumberForBackOrderLivingItem :
                                                                                specialItemList?.itemNumberForRtsProductitem ? specialItemList.itemNumberForRtsProductitem :
                                                                                    ""}
                                                            </span>
                                                            <span className={`${specialItemList?.shippingMethodForRtsProductitem && 'fwb text-ellipsis'}`}>
                                                                Shipping Method:&nbsp;
                                                                {specialItemList?.shippingMethodForDropShipItem ? specialItemList.shippingMethodForDropShipItem :
                                                                    specialItemList?.shippingMethodForGroundOnlyItem ? specialItemList.shippingMethodForGroundOnlyItem :
                                                                        specialItemList?.overNightMsg ? specialItemList.overNightMsg : // overNightMsg this is for softGoodsItem
                                                                            specialItemList?.shippingMethodForBackOrderLivingItem ? specialItemList.shippingMethodForBackOrderLivingItem :
                                                                                specialItemList?.shippingMethodForRtsProductitem ? specialItemList.shippingMethodForRtsProductitem : ""}
                                                            </span>
                                                            {specialItemList?.itemNumberForDropShipItem || specialItemList?.itemNumberForGroundOnlyItem ?
                                                                <span>
                                                                    Arriving: {specialItemList?.arrivalStartDateForDropShipItem ? Helper.dateFormatter(specialItemList.arrivalStartDateForDropShipItem) :
                                                                        specialItemList?.arrivalStartDateForGroundOnlyItem ? Helper.dateFormatter(specialItemList.arrivalStartDateForGroundOnlyItem) : ''} -
                                                                    {specialItemList?.arrivalEndDateForDropShipItem ? Helper.dateFormatter(specialItemList.arrivalEndDateForDropShipItem) :
                                                                        specialItemList?.arrivalEndDateForGroundOnlyItem ? Helper.dateFormatter(specialItemList.arrivalEndDateForGroundOnlyItem) : ''}
                                                                    &nbsp;<span class="fw-bold">{specialItemList?.backOrderTextMsgForDropShipItem}</span>
                                                                </span>
                                                                : specialItemList?.itemNumberForsoftGoodsItem ?
                                                                    <span>
                                                                        Arriving: {specialItemList?.arrivalStartDateForsoftGoodsItem ? Helper.dateFormatter(specialItemList.arrivalStartDateForsoftGoodsItem) : ''}
                                                                    </span>
                                                                    : specialItemList?.itemNumberForBackOrderLivingItem ?
                                                                        <span class="fwb text-ellipsis">
                                                                            Arriving: {specialItemList?.arrivalStartDateForBackOrderLivingItem ? Helper.dateFormatter(specialItemList.arrivalStartDateForBackOrderLivingItem) : ''}
                                                                            &nbsp;<span class="fw-bold">{specialItemList?.backOrderTextMsgForBackOrderLivingItem}</span>

                                                                        </span>
                                                                        : specialItemList?.itemNumberForRtsProductitem ?
                                                                            <span>
                                                                                Arriving: {specialItemList?.arrivalStartDateForRtsProductitem ? Helper.dateFormatter(specialItemList.arrivalStartDateForRtsProductitem) : ''} -
                                                                                {specialItemList?.arrivalEndDateForRtsProductitem ? Helper.dateFormatter(specialItemList.arrivalEndDateForRtsProductitem) : ''}
                                                                                &nbsp;<span class="fw-bold">
                                                                                    {specialItemList?.backOrderTextMsgForRtsProductitem}
                                                                                </span>
                                                                            </span>
                                                                            : ''
                                                            }
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col">
                                                    <div className="row g-0 g-md-4">

                                                        <div className="col ps-md-0 text-start text-md-end c-confirm-item-price c-item-price">

                                                            <span className="d-block d-md-none c-confirm-item-header py-2 mb-2">ITEM PRICE</span>

                                                            <span className="d-block c-confirm-item-value mb-1">
                                                                {userTypeRef.current && userTypeRef.current == 2 && specialItemList?.basePrice ? <>Your Contract Price&nbsp;</> : <></>}
                                                                <span className="fwb">{specialItemList?.yourPrice}</span>
                                                            </span>
                                                            {userTypeRef.current && userTypeRef.current == 2 && specialItemList?.basePrice &&
                                                                <span className="d-block c-confirm-item-value">
                                                                    Retail Price&nbsp;
                                                                    <del>{specialItemList.basePrice}</del>
                                                                </span>}

                                                        </div>
                                                        <div className="col text-center c-item-price">
                                                            <span className="d-block d-md-none c-confirm-item-header py-2 mb-2">QTY</span>
                                                            <span className="c-confirm-item-value">{specialItemList?.quantityForDropShipItem ? specialItemList.quantityForDropShipItem :
                                                                specialItemList?.quantityForGroundOnlyItem ? specialItemList.quantityForGroundOnlyItem :
                                                                    specialItemList?.quantityForsoftGoodsItem ? specialItemList.quantityForsoftGoodsItem :
                                                                        specialItemList?.quantityForBackOrderLivingItem ? specialItemList.quantityForBackOrderLivingItem :
                                                                            specialItemList?.quantityForRtsProductitem ? specialItemList.quantityForRtsProductitem :
                                                                                ""}
                                                            </span>
                                                        </div>
                                                        <div className="col ps-0 text-end c-item-price">
                                                            <span className="d-block d-md-none c-confirm-item-header py-2 mb-2">TOTAL</span>
                                                            <span className="c-confirm-item-value fwb">{specialItemList?.itemTotal ? specialItemList?.itemTotal : specialItemList?.amountTotal}</span>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </>
                                )) : ""}

                                {/* for livingProductItems */}
                                {livingProductItemRef.current ? livingProductItemRef.current.map((livingProducts) => (
                                    <>
                                        {livingProducts && Object.entries(livingProducts).map(([key, livingProduct], index) => (
                                            <div className="row c-confirm-item-list">
                                                <div className="col-12 col-md-6 col-lg-7 mb-2 mb-md-0">
                                                    <div className="row align-items-center c-confirm-item-desc">
                                                        <div className="col-12 d-md-none">
                                                            <div className="c-confirm-item-header pb-2 mb-2 c-order-title">
                                                                ITEM INFORMATION
                                                            </div>
                                                        </div>

                                                        <div className="col-auto"><img src={`${livingProduct?.imagePathForlivingMaterialItem ? livingProduct.imagePathForlivingMaterialItem : livingProduct?.imagePathForspeciallivingMaterialItem ? livingProduct.imagePathForspeciallivingMaterialItem : ""}`} onError={replaceImage} />
                                                        </div>
                                                        <div className="col-8 c-confirm-item-info c-confirm-item-size">
                                                            <span className="fwb text-ellipsis" dangerouslySetInnerHTML={{ __html: livingProduct?.productDescForlivingMaterialItem ? livingProduct.productDescForlivingMaterialItem : livingProduct?.productDescForspeciallivingMaterialItem ? livingProduct.productDescForspeciallivingMaterialItem : "" }}>
                                                            </span>
                                                            <span>
                                                                #{livingProduct?.itemNumberForlivingMaterialItem ? livingProduct.itemNumberForlivingMaterialItem :
                                                                    livingProduct?.itemNumberForspeciallivingMaterialItem ? livingProduct.itemNumberForspeciallivingMaterialItem : ""}
                                                            </span>
                                                            <span>
                                                                Shipping Method:&nbsp;
                                                                {livingProduct?.twoDayAirMsgForlivingMaterialItem ? livingProduct.twoDayAirMsgForlivingMaterialItem :
                                                                    livingProduct?.shippingMethodForlivingMaterialItem ? livingProduct.shippingMethodForlivingMaterialItem :
                                                                        livingProduct?.twoDayAirMsgForspeciallivingMaterialItem ? livingProduct.twoDayAirMsgForspeciallivingMaterialItem :
                                                                            livingProduct?.shippingMethodForspeciallivingMaterialItem ? livingProduct.shippingMethodForspeciallivingMaterialItem :
                                                                                ""}
                                                            </span>
                                                            <span>
                                                                Arriving: {livingProduct?.deliveryDateForlivingMaterialItem ? Helper.dateFormatter(livingProduct.deliveryDateForlivingMaterialItem) : livingProduct?.deliveryDateForspeciallivingMaterialItem ? Helper.dateFormatter(livingProduct.deliveryDateForspeciallivingMaterialItem) : ""}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col">
                                                    <div className="row g-0 g-md-4">

                                                        <div className="col ps-md-0 text-start text-md-end c-confirm-item-price c-item-price">

                                                            <span className="d-block d-md-none c-confirm-item-header py-2 mb-2">ITEM PRICE</span>

                                                            <span className="d-block c-confirm-item-value mb-1">
                                                                {livingProduct?.basePrice && <>Your Contract Price&nbsp;</>}
                                                                <span className="fwb">{livingProduct?.yourPrice && <>{livingProduct.yourPrice}</>}</span>
                                                            </span>
                                                            {userTypeRef.current && userTypeRef.current == 2 &&
                                                                <span className="d-block c-confirm-item-value">
                                                                    {livingProduct?.basePrice ? <>Retail Price&nbsp;<del>{livingProduct.basePrice}</del></> : ""}
                                                                </span>}
                                                        </div>
                                                        <div className="col text-center c-item-price">
                                                            <span className="d-block d-md-none c-confirm-item-header py-2 mb-2">QTY</span>
                                                            <span className="c-confirm-item-value">{livingProduct?.quantityForlivingMaterialItem ? livingProduct.quantityForlivingMaterialItem :
                                                                livingProduct?.quantityForspeciallivingMaterialItem ? livingProduct.quantityForspeciallivingMaterialItem : ""}</span>
                                                        </div>
                                                        <div className="col ps-0 text-end c-item-price">
                                                            <span className="d-block d-md-none c-confirm-item-header py-2 mb-2">TOTAL</span>
                                                            <span className="c-confirm-item-value fwb">{livingProduct?.itemTotal ? livingProduct?.itemTotal : livingProduct?.amountTotal}</span>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </>
                                )) : ""}
                                {/* for nonLivingProductItem */}
                                {nonLivingProductItemRef.current ? nonLivingProductItemRef.current.map((nonLivingProducts) => (
                                    <>
                                        {nonLivingProducts && Object.entries(nonLivingProducts).map(([key, nonLivingProduct], index) => (
                                            <div className="row c-confirm-item-list">
                                                <div className="col-12 col-md-6 col-lg-7 mb-2 mb-md-0">
                                                    <div className="row align-items-center c-confirm-item-desc">
                                                        <div className="col-12 d-md-none">
                                                            <div className="c-confirm-item-header pb-2 mb-2 c-order-title">
                                                                ITEM INFORMATION
                                                            </div>
                                                        </div>

                                                        <div className="col-auto"><img src={`${nonLivingProduct?.imagePathFornonLiveMaterialitem}`} onError={replaceImage} />
                                                        </div>
                                                        <div className="col-8 c-confirm-item-info c-confirm-item-size">
                                                            <span className="fwb text-ellipsis" dangerouslySetInnerHTML={{ __html: nonLivingProduct && nonLivingProduct.productDescFornonLiveMaterialitem ? nonLivingProduct.productDescFornonLiveMaterialitem : "" }}>
                                                            </span>
                                                            <span>
                                                                #{nonLivingProduct?.itemNumberFornonLiveMaterialitem}
                                                            </span>
                                                            <span>
                                                                Shipping Method:&nbsp;
                                                                {nonLivingProduct?.shippingMethodFornonLiveMaterialitem}
                                                            </span>
                                                            {/* <span>
                                                                Arriving: {nonLivingProduct?.arrivalStartDateFornonLiveMaterialitem && Helper.dateFormatter(nonLivingProduct.arrivalStartDateFornonLiveMaterialitem)} - {nonLivingProduct?.arrivalEndDateFornonLiveMaterialitem && Helper.dateFormatter(nonLivingProduct.arrivalEndDateFornonLiveMaterialitem)}
                                                            </span> */}
                                                            {nonLivingProduct?.shippingMethodFornonLiveMaterialitem == "Standard Ground" && orderConfirmationDetailsRef.current?.shippingPreferenceForNonLiving == "ship-Later" ?
                                                                <span>
                                                                    Arriving: {nonLivingProduct?.arrivalStartDateFornonLiveMaterialitem && Helper.dateFormatter(nonLivingProduct.arrivalStartDateFornonLiveMaterialitem)}
                                                                </span>
                                                                : nonLivingProduct?.shippingMethodFornonLiveMaterialitem !== "Standard Ground" ?
                                                                    <span>
                                                                        Arriving: {nonLivingProduct?.arrivalStartDateFornonLiveMaterialitem && Helper.dateFormatter(nonLivingProduct.arrivalStartDateFornonLiveMaterialitem)}
                                                                    </span> :
                                                                    <span>
                                                                        Arriving: {nonLivingProduct?.arrivalStartDateFornonLiveMaterialitem && Helper.dateFormatter(nonLivingProduct.arrivalStartDateFornonLiveMaterialitem)} - {nonLivingProduct?.arrivalEndDateFornonLiveMaterialitem && Helper.dateFormatter(nonLivingProduct.arrivalEndDateFornonLiveMaterialitem)}
                                                                    </span>}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col">
                                                    <div className="row g-0 g-md-4">

                                                        <div className="col ps-md-0 text-start text-md-end c-confirm-item-price c-item-price">

                                                            <span className="d-block d-md-none c-confirm-item-header py-2 mb-2">ITEM PRICE</span>

                                                            <span className="d-block c-confirm-item-value mb-1">
                                                                {userTypeRef.current && userTypeRef.current == 2 && nonLivingProduct?.basePrice ? <>Your Contract Price&nbsp;</> : ''}
                                                                <span className="fwb">{nonLivingProduct?.yourPrice}</span>
                                                            </span>
                                                            {userTypeRef.current && userTypeRef.current == 2 && nonLivingProduct?.basePrice &&
                                                                <span className="d-block c-confirm-item-value">
                                                                    Retail Price&nbsp;
                                                                    <del>{nonLivingProduct.basePrice}</del>
                                                                </span>}
                                                        </div>
                                                        <div className="col text-center c-item-price">
                                                            <span className="d-block d-md-none c-confirm-item-header py-2 mb-2">QTY</span>
                                                            <span className="c-confirm-item-value">{nonLivingProduct?.quantityFornonLiveMaterialitem}</span>
                                                        </div>
                                                        <div className="col ps-0 text-end c-item-price">
                                                            <span className="d-block d-md-none c-confirm-item-header py-2 mb-2">TOTAL</span>
                                                            <span className="c-confirm-item-value fwb">{nonLivingProduct?.itemTotal ? nonLivingProduct?.itemTotal : nonLivingProduct?.amountTotal}</span>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </>
                                )) : ""}

                                {isRedeemRef.current ?
                                    <>

                                        {livingVouchersRef.current?.map((voucher, index) => {
                                            return (
                                                voucher?.voucherId && voucher.voucherId.trim() != '' ?
                                                    <div class="row c-confirm-item-list">
                                                        <div class="col-12 col-md-6 col-lg-7 mb-2 mb-md-0">
                                                            <div class="row align-items-center c-confirm-item-desc">
                                                                <div className="col-12 d-md-none">
                                                                    <div className="c-confirm-item-header pb-2 mb-2 c-order-title">
                                                                        ITEM INFORMATION
                                                                    </div>
                                                                </div>
                                                                <div className="col-8 c-confirm-item-info-redeem">
                                                                    <span>Code: {voucher?.voucherId}</span><br />
                                                                    <span className="d-inline-flex"><label className="me-1">Arriving: </label>
                                                                        {voucher?.livingDeliverydate}
                                                                    </span>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    : <></>

                                            )
                                        })}
                                        {
                                            curriculamVouchersRef.current?.map((voucher, index) => {
                                                return (<>
                                                    {voucher?.voucherId && voucher.voucherId.trim() != '' &&
                                                        <div class="row c-confirm-item-list">
                                                            <div class="col-12 col-md-6 col-lg-7 mb-2 mb-md-0">
                                                                <div class="row align-items-center c-confirm-item-desc">
                                                                    <div className="col-12 d-md-none">
                                                                        <div className="c-confirm-item-header pb-2 mb-2 c-order-title">
                                                                            ITEM INFORMATION
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-8 c-confirm-item-info-redeem">
                                                                        <span>Code: {voucher.voucherId}</span><br />
                                                                        <span>{voucher.schoolName}</span><br />
                                                                        <span>{voucher.courseTitle}</span><br />
                                                                        <span>{voucher.courseId}</span><br />
                                                                        <span className="d-inline-flex"><label className="me-1">Arriving: </label>
                                                                            {voucher.curriculamDeliverydate}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                </>
                                                )
                                            })
                                        }
                                        {
                                            distanceLearningVouchersRef.current?.map((voucher, index) => {
                                                return (
                                                    voucher?.voucherId && voucher.voucherId.trim() != '' ?
                                                        <div class="row c-confirm-item-list">
                                                            <div class="col-12 col-md-6 col-lg-7 mb-2 mb-md-0">
                                                                <div class="row align-items-center c-confirm-item-desc">
                                                                    <div className="col-12 d-md-none">
                                                                        <div className="c-confirm-item-header pb-2 mb-2 c-order-title">
                                                                            ITEM INFORMATION
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-8 c-confirm-item-info-redeem">
                                                                        <span>Code: {voucher.voucherId}</span><br />
                                                                        <span>{voucher.schoolName}</span><br />
                                                                        <span>{voucher.courseTitle}</span><br />
                                                                        <span>{voucher.courseId}</span><br />
                                                                        <span className="d-inline-flex"><label className="me-1">Arriving: </label>
                                                                            {voucher?.deliveryMessage}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div> : <></>
                                                )
                                            })
                                        }


                                    </>
                                    : ""}
                            </div>
                        </div>
                    </section>

                    {orderConfirmationDetailsRef.current?.specialInstruction &&
                        <div className="row">
                            <div className="col-md-12">
                                <div className="c-confirm-order-header">
                                    <h2>
                                        ADDITIONAL INSTRUCTIONS
                                    </h2>
                                </div>
                                <p className="c-delivery-item-text py-3">
                                    {orderConfirmationDetailsRef.current?.specialInstruction}
                                </p>
                            </div>
                        </div>}

                    <div className="row mb-5">
                        <div className="col-12 col-md-12 text-end">
                            <Link to="/" className='c-order-btn-padding'>
                                <button type="submit" className="btn btn-secondary block">Continue Shopping</button>
                            </Link>
                            <Link to={{ pathname: profileDetail && profileDetail.transient === true ? '/account/login' : orderConfirmationDetailsRef.current?.myAccountUrl ? orderConfirmationDetailsRef.current.myAccountUrl.substr(0, orderConfirmationDetailsRef.current.myAccountUrl.indexOf(".")) : redeemOrderConfirmationDetailsRef.current?.myAccountURL ? redeemOrderConfirmationDetailsRef.current.myAccountURL.substr(0, redeemOrderConfirmationDetailsRef.current.myAccountURL.indexOf(".")) : "", state: { previousUrl: '/checkout/confirm' } }} className=''>
                                <button type="submit" className="btn btn-secondary block ml-2">My Account</button>
                            </Link>
                        </div>
                    </div>

                </div>
            </div>
            <div className='d-none' id='pepperjamContainer'>
            </div>
            <div className='d-none' id='customPixelTrackingContainer'>
            </div>
        </div>
    );
};

export default OrderConfirmation;
